// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Page Styling */
.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

/* Upload Section Styling */
.upload-section {
  margin-bottom: 40px;
}

.upload-section h2 {
  font-size: 20px; /* Reduced font size */
  margin-bottom: 15px;
  color: #343a40;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.upload-section input,
.upload-section textarea,
.upload-section button {
  display: block;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
  font-size: 13px; /* Reduced font size */
  border: 1px solid #ced4da;
  border-radius: 5px;
  box-sizing: border-box;
}

.upload-section button {
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border: none;
}

.upload-section button:hover {
  background-color: #0056b3;
}

/* Table Layout for All Sections */
.table-container {
  overflow-x: auto;
  margin-bottom: 40px;
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: #f8f9fa;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px; /* Reduced padding */
  text-align: left;
  font-size: 12px; /* Smaller text */
  word-wrap: break-word;
}

th {
  background-color: #007bff;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
}

td {
  color: #495057;
}

tr:hover {
  background-color: #f1f3f5;
}

/* Updates List Styled as Table */
.render-section {
  margin-bottom: 40px;
}

.render-section h2 {
  font-size: 20px; /* Reduced font size */
  margin-bottom: 15px;
  color: #343a40;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.updates-list {
  display: block; /* Changed to block for table layout */
}

.update-item2 {
  display: table-row; /* Styled as table row */
  background: transparent;
  border: none;
  width: auto;
  box-shadow: none;
  padding: 0;
}

.update-item2 h3,
.update-item2 p {
  display: table-cell; /* Styled as table cell */
  padding: 10px;
  font-size: 12px;
  vertical-align: middle;
}

.update-item2 .update-image {
  display: table-cell; /* Styled as table cell */
  max-width: 60px;
  max-height: 60px;
  border-radius: 5px;
  object-fit: cover;
  margin-bottom: 0;
  vertical-align: middle;
}

.update-item2 button.delete {
  background-color: #dc3545;
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  border: none;
  font-size: 11px; /* Smaller text */
  cursor: pointer;
}

.update-item2 button.delete:hover {
  background-color: #c82333;
}

/* Placeholder Message */
.placeholder {
  text-align: center;
  padding: 20px;
  font-size: 14px; /* Reduced font size */
  color: #6c757d;
}

/* Responsive Design */
@media (max-width: 768px) {
  table {
    font-size: 11px; /* Adjust font size for smaller screens */
  }

  th,
  td {
    padding: 6px; /* Reduced padding */
  }

  .update-item2 .update-image {
    max-width: 40px;
    max-height: 40px;
  }

  .upload-section input,
  .upload-section textarea,
  .upload-section button {
    font-size: 11px;
  }
}

/* Font Customization for Table Rows */
th,
td {
  font-family: 'Arial', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPanel.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,sBAAsB;EACvC,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe,EAAE,sBAAsB;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY,EAAE,oBAAoB;EAClC,gBAAgB;EAChB,eAAe,EAAE,iBAAiB;EAClC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,sBAAsB;EACvC,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,sCAAsC;AACxD;;AAEA;EACE,kBAAkB,EAAE,wBAAwB;EAC5C,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,mBAAmB,EAAE,yBAAyB;EAC9C,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB,EAAE,yBAAyB;EAC9C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe,EAAE,iBAAiB;EAClC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe,EAAE,sBAAsB;EACvC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe,EAAE,yCAAyC;EAC5D;;EAEA;;IAEE,YAAY,EAAE,oBAAoB;EACpC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;;EAEE,gCAAgC;AAClC","sourcesContent":["/* General Page Styling */\r\n.page-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n/* Upload Section Styling */\r\n.upload-section {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.upload-section h2 {\r\n  font-size: 20px; /* Reduced font size */\r\n  margin-bottom: 15px;\r\n  color: #343a40;\r\n  border-bottom: 2px solid #ddd;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.upload-section input,\r\n.upload-section textarea,\r\n.upload-section button {\r\n  display: block;\r\n  width: 100%;\r\n  margin-bottom: 10px;\r\n  padding: 10px;\r\n  font-size: 13px; /* Reduced font size */\r\n  border: 1px solid #ced4da;\r\n  border-radius: 5px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.upload-section button {\r\n  background-color: #007bff;\r\n  color: white;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  border: none;\r\n}\r\n\r\n.upload-section button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n/* Table Layout for All Sections */\r\n.table-container {\r\n  overflow-x: auto;\r\n  margin-bottom: 40px;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\nth,\r\ntd {\r\n  border: 1px solid #ddd;\r\n  padding: 8px; /* Reduced padding */\r\n  text-align: left;\r\n  font-size: 12px; /* Smaller text */\r\n  word-wrap: break-word;\r\n}\r\n\r\nth {\r\n  background-color: #007bff;\r\n  color: white;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n}\r\n\r\ntd {\r\n  color: #495057;\r\n}\r\n\r\ntr:hover {\r\n  background-color: #f1f3f5;\r\n}\r\n\r\n/* Updates List Styled as Table */\r\n.render-section {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.render-section h2 {\r\n  font-size: 20px; /* Reduced font size */\r\n  margin-bottom: 15px;\r\n  color: #343a40;\r\n  border-bottom: 2px solid #ddd;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.updates-list {\r\n  display: block; /* Changed to block for table layout */\r\n}\r\n\r\n.update-item2 {\r\n  display: table-row; /* Styled as table row */\r\n  background: transparent;\r\n  border: none;\r\n  width: auto;\r\n  box-shadow: none;\r\n  padding: 0;\r\n}\r\n\r\n.update-item2 h3,\r\n.update-item2 p {\r\n  display: table-cell; /* Styled as table cell */\r\n  padding: 10px;\r\n  font-size: 12px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.update-item2 .update-image {\r\n  display: table-cell; /* Styled as table cell */\r\n  max-width: 60px;\r\n  max-height: 60px;\r\n  border-radius: 5px;\r\n  object-fit: cover;\r\n  margin-bottom: 0;\r\n  vertical-align: middle;\r\n}\r\n\r\n.update-item2 button.delete {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  padding: 5px 10px;\r\n  border-radius: 3px;\r\n  border: none;\r\n  font-size: 11px; /* Smaller text */\r\n  cursor: pointer;\r\n}\r\n\r\n.update-item2 button.delete:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n/* Placeholder Message */\r\n.placeholder {\r\n  text-align: center;\r\n  padding: 20px;\r\n  font-size: 14px; /* Reduced font size */\r\n  color: #6c757d;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  table {\r\n    font-size: 11px; /* Adjust font size for smaller screens */\r\n  }\r\n\r\n  th,\r\n  td {\r\n    padding: 6px; /* Reduced padding */\r\n  }\r\n\r\n  .update-item2 .update-image {\r\n    max-width: 40px;\r\n    max-height: 40px;\r\n  }\r\n\r\n  .upload-section input,\r\n  .upload-section textarea,\r\n  .upload-section button {\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n/* Font Customization for Table Rows */\r\nth,\r\ntd {\r\n  font-family: 'Arial', sans-serif;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
